import { publicIdentifierStorageKey } from '../constants/app'

export default function enterprise() {
  const publicIdentifier = localStorage.getItem(publicIdentifierStorageKey)

  return !['production', 'staging'].includes(publicIdentifier)
}
